import React, {Fragment, useEffect, useState} from 'react';

import {getSchoolGroups} from '../Forms/UI/DropdownDataProviders' ;

import { renderDropdown, renderDropdownReadOnly} from "./DropdownFunctions";

import SpinnerDiv from "./SpinnerDiv";
import PropTypes from "prop-types";

const DropdownSchoolGroups = ( props ) =>
{
    const [ data, setData ] = useState ( { loading: true, items : [] } ) ;

    useEffect(() => {
        getSchoolGroups(1).then (response =>
        {
            let items = response ;

            if ( props.includeAll === true )
            {
                items = [ { value: 0, label: 'All Schools' }, ...items ]
            }

            setData ( { loading: false, items: items }) ;
        })
    }, []);

    const options = {
        isSearchable: true,
        isClearable: props.isClearable === null || props.isClearable === undefined ? true : props.isClearable,
    }

    return data.loading === true ? <SpinnerDiv/> :
    (
        props.readOnly === 'readonly' ? renderDropdownReadOnly(props, data) : renderDropdown(props, data, options)
    )
}

export default DropdownSchoolGroups;

DropdownSchoolGroups.defaultProps =
{
    defaultClassName: ''
}

DropdownSchoolGroups.propTypes = {
    onChange: PropTypes.func.isRequired
};
